import { createContext } from 'react';

const ResourceContext = createContext(0);

export default ResourceContext;
